module.exports = __webpack_public_path__ + "img/benoit21.62644bf9.jpg";